import { FC } from "react";
import { pluralizeWithCount } from "@common/helpers/string";
import { CommandsListProps } from "./lib";
import { TaskBulkOptionsCommandsList } from "./TaskBulkOptionsCommandsList";

export const LineItemsBulkReceivablesCommandsList: FC<CommandsListProps> = ({
    options = {},
}) => {
    const {
        selectedLineItemCount = 0,
        hasSelectedAllMatchingLineItems = false,
        lineItemsBulkReceivablesOptions = [],
    } = options;

    const selectionDescription = hasSelectedAllMatchingLineItems
        ? "all matching line items"
        : pluralizeWithCount("line item", selectedLineItemCount);

    return (
        <TaskBulkOptionsCommandsList
            heading={`Set receivables account for ${selectionDescription}`}
            options={lineItemsBulkReceivablesOptions}
        />
    );
};
